import(/* webpackMode: "eager" */ "/workspace/app/[locale]/error.tsx");
